module.exports = __webpack_public_path__ + "media/swipe.650e9b77.mp4";